module.exports = __webpack_public_path__ + "static/img/home-banners-mob2.64497f2b.jpg";